import { Link } from "react-router-dom";
import SunAccent from "@/components/feature/SunAccent";
import Reveal from "@/components/base/Reveal";

export default function StoryArticleCta({ author }: { author: string }) {
  return (
    <section className="sun-glaze bg-primary-950 py-20 md:py-28 relative overflow-hidden">
      <div className="absolute inset-0 grain opacity-30"></div>
      <div className="relative w-full px-4 md:px-8">
        <Reveal>
          <div className="max-w-3xl">
            <div className="flex items-center gap-3 mb-5">
              <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" /><span className="h-px w-10 bg-accent-400"></span>
              <span className="text-xs font-semibold tracking-[0.24em] uppercase text-accent-300">
                Walk These Fields
              </span>
            </div>
            <h2 className="font-heading text-3xl md:text-5xl leading-tight text-background-50 font-semibold">
              Every Story Begins at a Farm
            </h2>
            <p className="mt-5 text-base md:text-lg text-background-200 leading-relaxed">
              Stories like this one are written by farmers, and they are best understood in person.
              Meet {author} and the families behind Rythugaru on a real farm visit.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <Link
                to="/experiences/farmer-for-a-day"
                className="inline-flex items-center justify-center gap-2 bg-accent-500 text-background-50 text-sm font-semibold px-7 py-4 rounded-md hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Experience this farm
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/stories"
                className="inline-flex items-center justify-center gap-2 bg-background-50/10 border border-background-50/25 text-background-50 text-sm font-semibold px-7 py-4 rounded-md hover:bg-background-50/20 transition-colors whitespace-nowrap cursor-pointer"
              >
                Back to all stories
                <i className="ri-book-open-line"></i>
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}